define('Extended.ReorderItems.Model'
    , ['Item.Model'
        , 'Transaction.Line.Model'
        , 'underscore'
        , 'Utils'
    ]
    , function (
        ItemModel
        , TransactionLineModel
        , _
        , Utils
    ) {
        'use strict';

        //@class ReorderItems.Model @extend Backbone.Model
        return TransactionLineModel.extend({

            //@property {String} urlRoot
            urlRoot: Utils.getAbsoluteUrl('services/ReorderItems.Service.ss')

            //@property {Object} validation
            , validation: {}

            //@method parse
            //@param {Object} record
            //@return {Object}
            , parse: function parse(record) {
                if (record.item) {
                    var item_options = _.filter(record.options, function (option) {
                        return option.value !== '';
                    });

                    record.internalid = record.item.internalid + '|' + JSON.stringify(item_options).replace(/"/g, '\'');
                }
                return record;
            }
        });
    });
